<svg width="13px" height="10px" viewBox="0 0 13 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="ui/icon/tick" stroke-width="2">
            <polyline class="tick" [ngClass]='{active: isActive}' points="1 4.71644431 4.55830607 8 12 1" stroke-width="2"></polyline>
        </g>
    </g>
</svg>